module.exports = __webpack_public_path__ + "static/media/SHIMANO-CONCEPT-FONDO-BLANCO.98423a63.jpg";